import { Header } from "./Header";
import { Footer } from "./Footer";
import { GoogleFloat } from "./GoogleFloat";
import { CookieBanner } from "./CookieBanner";
import { useLocale } from "../i18n/LocaleContext";

export function Layout({ children }) {
  const { t } = useLocale();
  return (
    <div className="min-h-screen bg-imperium-white">
      <a href="#content" data-testid="skip-to-content" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:bg-imperium-brown focus:px-4 focus:py-2 focus:text-imperium-white">
        {t("nav.home")}
      </a>
      <Header />
      <main id="content">{children}</main>
      <Footer />
      <GoogleFloat />
      <CookieBanner />
    </div>
  );
}
